<template>
    <path
        fill="none"
        stroke="currentColor"
        stroke-width="0.9"
        stroke-linejoin="round"
        stroke-linecap="round"
        d="M13.2 2.8L9.6 13.2L7.45 8.55L2.8 6.6ZM13.2 2.8L7.45 8.55"
    />
</template>
